import { FEATURES } from "@/core/constants/features";

export default {
  computed: {
    FEATURES() {
      return FEATURES;
    },
  },
  methods: {
    hasFeature(code) {
      return this.$store.getters.hasFeature(code);
    },
  },
};
